import React from 'react'
import { Box } from 'rebass'

import PreorderBlock from '../components/PreorderBlock'

const PreorderUpper = () => (
  <Box py={[50, 100]}>
    <PreorderBlock />
  </Box>
)

export default PreorderUpper
